import { WidgetInfo } from 'widgets/WidgetInfo';
import { PortfolioSelection } from 'portfolio/PortfolioSelection';

export type ActiveInputType =
    | 'None'
    | 'Embedded App'
    | 'Position Entry'
    | 'Widget';

export interface PortfolioState {
    activeInputType: ActiveInputType;
    activeInputWidget?: WidgetInfo;
    selection?: PortfolioSelection;
}

export const initialPortfolioState: PortfolioState = {
    activeInputType: 'None',
};
